
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/toaster";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Destinations from "@/components/Destinations";
import Testimonials from "@/components/Testimonials";
import Blog from "@/components/Blog";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import { ApplicationForm } from "@/components/ApplicationForm";
import { ConsultationForm } from "@/components/ConsultationForm";

function App() {
  const [language, setLanguage] = useState("en");
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [showConsultationForm, setShowConsultationForm] = useState(false);

  // Update document language and direction
  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.body.className = language === "ar" ? "lang-ar" : language === "so" ? "lang-so" : "";
  }, [language]);

  return (
    <div className={`min-h-screen bg-background ${language === "ar" ? "lang-ar" : language === "so" ? "lang-so" : ""}`}>
      <Navbar 
        language={language} 
        setLanguage={setLanguage}
        onApplyClick={() => setShowApplicationForm(true)}
        onConsultClick={() => setShowConsultationForm(true)}
      />
      <main>
        <section id="home">
          <Hero 
            language={language}
            onApplyClick={() => setShowApplicationForm(true)}
            onConsultClick={() => setShowConsultationForm(true)}
          />
        </section>
        <section id="about">
          <About language={language} />
        </section>
        <section id="services">
          <Services language={language} />
        </section>
        <section id="destinations">
          <Destinations language={language} />
        </section>
        <section id="blog">
          <Blog language={language} />
        </section>
        <section id="testimonials">
          <Testimonials language={language} />
        </section>
        <section id="contact">
          <ContactForm language={language} />
        </section>
      </main>
      <Footer language={language} />
      
      <motion.a
        href="https://wa.me/447368303370?text=Hi!%20👋%20How%20can%20we%20help%20you%20get%20started%20with%20your%20studies%20abroad?"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <MessageCircle size={24} />
      </motion.a>

      <ApplicationForm 
        language={language}
        open={showApplicationForm}
        onOpenChange={setShowApplicationForm}
      />
      
      <ConsultationForm
        language={language}
        open={showConsultationForm}
        onOpenChange={setShowConsultationForm}
      />

      <Toaster />
    </div>
  );
}

export default App;
